<div class="row modal-bar">
    <div class="col-sm-6">
        <h5 class="modal-title">{{data.title}}</h5>
    </div>
    <div class="col-sm-6">
        <div class="modal-actions">
            <div class="modal-close">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
            </div>
        </div>
    </div>
</div>
<div class="modal-body p-5">
    <div class="mg-b-5">
        @if (data.lines) {
            <div><b>{{ data.headerText }}</b></div>
            <br />
            @for (line of data.lines; track $index) {
                <div [class.file-import-result-line--warning]="data.isWarning" [class.file-import-result-line--error]="!data.isWarning">
                    <span><i class="fas" [ngClass]="data.isWarning ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'"></i>&nbsp;{{ line }}</span>
                </div>
                <br />
            }
        } @else {
            {{ data.message }}
        }
    </div>
</div>
<div class="modal-footer">
    <div class="col-6">
      <button type="button" class="btn btn-block btn-secondary" (click)="dialogRef.close(false);">{{ 'BTN.CLOSE' | translate }}</button>
    </div>
</div>
